import { render } from "./TimerBoard.vue?vue&type=template&id=154c8b72"
import script from "./TimerBoard.vue?vue&type=script&lang=js"
export * from "./TimerBoard.vue?vue&type=script&lang=js"
script.render = render

export default script